module.exports = __webpack_public_path__ + "static/media/image5.e495b1a5.svg";